import Vue from 'vue'
import Buefy from 'buefy'
import CustomPageForm from './App.vue'

Vue.use(Buefy,{
    defaultIconPack: 'fas',
})

Vue.use(CustomPageForm)

if (document.getElementById("pagesFormStaffApp")){
    new Vue({
        render:h=>h(
            CustomPageForm,{
                props:{
                    createPageUrl: document.getElementById("pagesFormStaffApp")
                        .getAttribute("create-page"),
                    isEdit: document.getElementById("pagesFormStaffApp")
                        .getAttribute("is-edit"),
                    editUrl: document.getElementById("pagesFormStaffApp")
                        .getAttribute("edit-url"),
                    listUrl: document.getElementById("pagesFormStaffApp")
                        .getAttribute("list-url")
                }
            }
        )
    }).$mount("#pagesFormStaffApp")
}